import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TLocationManagementActions, GetLocalNeedleStoresSuccess } from './location-management.actions';
import { TLocationManagementState, TLocationManagementActionType } from './location-management.models';

export const LOCATION_LIST_FEATURE_KEY = 'locationList';

export const intialState: TLocationManagementState = {
  locationListingInfo: null,
  assignEmployeeDropdown: null,
  floatingAreaFloorsForLocationDeletion: null,
  localNeedleStoresInfo: null,
  locationListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function locationManagementReducer(
  state = intialState,
  action: TLocationManagementActions,
): TLocationManagementState {
  switch (action.type) {
    case TLocationManagementActionType.SetLocationListPagination:
      return {
        ...state,
        locationListingPagination: action.pagination,
      };
    case TLocationManagementActionType.GetLocationList:
      return {
        ...state,
        locationListingInfo: null,
      };
    case TLocationManagementActionType.GetLocationListSuccess:
      return {
        ...state,
        locationListingInfo: {
          res: action.locationListRes,
          fetchReason: action.fetchReason,
        },
      };
    case TLocationManagementActionType.AssignEmployeeDropdown:
      return {
        ...state,
        assignEmployeeDropdown: null,
      };
    case TLocationManagementActionType.AssignEmployeeDropdownSuccess:
      return {
        ...state,
        assignEmployeeDropdown: action.assignEmployeeDropdownRes,
      };
    case TLocationManagementActionType.GetFloatingAreaFloorsForLocationDeletion:
      return {
        ...state,
        floatingAreaFloorsForLocationDeletion: null,
      };
    case TLocationManagementActionType.GetFloatingAreaFloorsForLocationDeletionSuccess:
      return {
        ...state,
        floatingAreaFloorsForLocationDeletion: action.res,
      };
    case TLocationManagementActionType.GetLocalNeedleStoresSuccess:
      return {
        ...state,
        localNeedleStoresInfo: action.res,
      };
    default:
      return state;
  }
}
